import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import MenuForm from './MenuForm';
import Menu from '../../models/menu';

const EditMenu = ({ setPageTitle }) => {
  const { id } = useParams();
  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const menuModel = new Menu();
        const data = await menuModel.getMenuById(id);
        if (data) {
          setMenuData(data);
        }
      } catch (err) {
        console.error('Error fetching menu:', err);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchMenu();
  }, [id]);

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, textAlign: 'center' }}>
        Đang tải...
      </Container>
    );
  }

  if (!menuData) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, textAlign: 'center' }}>
        Không tìm thấy menu
      </Container>
    );
  }

  return <MenuForm initialData={menuData} isEdit={true} setPageTitle={setPageTitle} />;
};

export default EditMenu;
